import type { BlogArticlesFragment } from '~/client/components/Blog/graphql/BlogArticlesQuery.generated';
import type ArticleType from '~/client/components/Blog/shared/articles/BlogArticle/ArticleType';
import useLanguage from '~/client/hooks/useLanguage';
import Container from './styles/Container';
import Meta from './styles/Meta';
import Preview from './styles/Preview';
import Title from './styles/Title';

type Props = {
  article: BlogArticlesFragment['node'];
  type: ArticleType;
  size: 'big' | 'small';
  showPreview?: boolean;
};

const ArticleBody: FC<Props> = ({ article, type, size, showPreview }) => {
  const { locale } = useLanguage();
  const date = new Date(article?.publishDate ?? '').toLocaleDateString(locale);
  return (
    <Container size={size} type={type}>
      <Title size={size} type={type}>
        {article?.title}
      </Title>
      {showPreview && (
        <Preview
          as="h5"
          size={18}
          dangerouslySetInnerHTML={{ __html: article?.mainBlock ?? '' }}
        />
      )}
      <Meta>
        <span>{date}</span>
      </Meta>
    </Container>
  );
};

export default ArticleBody;
